import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { formatDollars } from '../../../../../../utils/formatting';
import Timestamp from '../../../../../../Timestamp';
import UserAvatar from '../../../../../../User/Avatar/UserAvatar';
import UserLink from '../../../../../../User/Link/UserLink';
import Stack from '../Stack';
import Gifted from '../Gifted';

import s from './OwnerRow.scss';

interface Props {
  user: PapiUser;
  sellPrice?: number;
  sellTimestamp: string;
  wasGifted?: boolean;
}

const OwnerRow: React.FC<Props> = ({
  user,
  sellPrice,
  sellTimestamp,
  wasGifted,
}) => {
  const { t } = useTranslation();

  return (
    <Section className={s['root']}>
      <div className={s['avatar-and-name']}>
        <UserAvatar size={32} user={user} />
        <Stack>
          <Heading className={s['username-headnote']}>
            {t('sidebar.exclusives.currentOwner.usernameHeadnote')}
          </Heading>
          <UserLink className={s['username']} user={user} />
        </Stack>
      </div>
      <Stack className={s['details']}>
        {wasGifted && <Gifted />}
        {!wasGifted && sellPrice && (
          <span className={s['detail']}>
            {t('sidebar.exclusives.currentOwner.detail.sellPrice', {
              price: formatDollars(sellPrice),
            })}
          </span>
        )}
        <Timestamp timestamp={sellTimestamp} className={s['detail']} />
      </Stack>
    </Section>
  );
};

OwnerRow.displayName = 'OwnerRow';

export default OwnerRow;
